import { colors } from '@material-ui/core'

const MANUAL_SOURCE_ID = 'manual'
const SYSTEM_SOURCE_ID = 'system'
const DAI_SOURCE_ID = 'dai'

const INITIAL_STATUS_ID = 'initial'
const HEADWAY_STATUS_ID = 'headway'
const CONCLUSION_STATUS_ID = 'conclusion'
const INACTIVE_STATUS_ID = 'inactive'
const OVERDUE_STATUS_ID = 'overdue'

const EVIDENCE_FILE_TYPES = '.jpg,.jpeg,.png,.pdf,.doc,.docx,.xls,.xlsx'
const EVIDENCE_FILE_MIMES_TYPES = [
  'image/jpeg',
  'image/png',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
]

const PLAN_ACTION_FIELDS_CONTROLLER = [
  {
    name: 'what',
    label: 'O que?',
    placeholder: 'Ações concretas e objetivas que serão tomadas',
    rows: 4,
    md: 12,
  },
  {
    name: 'how',
    label: 'Como?',
    placeholder: 'Planejamento para execução da ação',
    rows: 4,
    md: 6,
  },
  {
    name: 'because',
    label: 'Por quê?',
    placeholder: 'A meta que se objetiva com a ação',
    rows: 4,
    md: 6,
  },
  {
    name: 'where',
    label: 'Onde?',
    placeholder: 'Em qual setor a ação será realizada',
    md: 6,
  },
  {
    name: 'howPrice',
    label: 'Quanto?',
    placeholder: 'Impacto financeiro da ação (R$)',
    startIcon: 'R$',
    inputMode: 'decimal',
    md: 6,
  },
]

const CHIP_STATUS_TEXT_COLORS = {
  [INITIAL_STATUS_ID]: colors.orange[900],
  [HEADWAY_STATUS_ID]: colors.blue[900],
  [CONCLUSION_STATUS_ID]: colors.green[900],
  [INACTIVE_STATUS_ID]: colors.grey[900],
  [OVERDUE_STATUS_ID]: colors.red[900],
}

const CHIP_STATUS_COLORS = {
  [INITIAL_STATUS_ID]: colors.orange[100],
  [HEADWAY_STATUS_ID]: colors.blue[100],
  [CONCLUSION_STATUS_ID]: colors.green[100],
  [INACTIVE_STATUS_ID]: colors.grey[100],
  [OVERDUE_STATUS_ID]: colors.red[100],
}

const CHIP_STATUS_LABELS = {
  [INITIAL_STATUS_ID]: 'Pendente',
  [HEADWAY_STATUS_ID]: 'Em andamento',
  [CONCLUSION_STATUS_ID]: 'Concluído',
  [INACTIVE_STATUS_ID]: 'Inativo',
  [OVERDUE_STATUS_ID]: 'Atrasado',
}
const PLAN_ACTION_FIELDS_CONTROLLER_CHANGES_MANAGEMENT = [
  {
    name: 'what',
    label: 'O que? *',
    placeholder: 'Ações concretas e objetivas que serão tomadas',
    rows: 4,
    md: 12,
  },
  {
    name: 'how',
    label: 'Como?',
    placeholder: 'Planejamento para execução da ação',
    rows: 4,
    md: 6,
  },
  {
    name: 'because',
    label: 'Por quê?',
    placeholder: 'A meta que se objetiva com a ação',
    rows: 4,
    md: 6,
  },
  {
    name: 'where',
    label: 'Onde?',
    placeholder: 'Em qual setor a ação será realizada',
    md: 6,
  },
  {
    name: 'howPrice',
    label: 'Quanto?',
    placeholder: 'Impacto financeiro da ação (R$)',
    startIcon: 'R$',
    inputMode: 'decimal',
    md: 6,
  },
]

export default {
  CONCLUSION_STATUS_ID,
  DAI_SOURCE_ID,
  MANUAL_SOURCE_ID,
  SYSTEM_SOURCE_ID,
  EVIDENCE_FILE_MIMES_TYPES,
  EVIDENCE_FILE_TYPES,
  HEADWAY_STATUS_ID,
  INACTIVE_STATUS_ID,
  INITIAL_STATUS_ID,
  OVERDUE_STATUS_ID,
  CHIP_STATUS_COLORS,
  CHIP_STATUS_LABELS,
  CHIP_STATUS_TEXT_COLORS,
  PLAN_ACTION_FIELDS_CONTROLLER_CHANGES_MANAGEMENT,
  PLAN_ACTION_FIELDS_CONTROLLER,
}
